import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  DEFAULT_LANGUAGE,
  detectLanguageFromPath,
  buildLocalizedUrl,
  persistLanguage,
  persistAuthLanguage,
  resolveLanguageFromParam,
  SUPPORTED_LANGUAGES,
} from '@/utils/languageRouting.js';

const AuthLanguageSwitcher = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { i18n } = useTranslation('dashboard');

  const languageFromPath = detectLanguageFromPath(location.pathname);
  const currentLanguage = useMemo(
    () => resolveLanguageFromParam(languageFromPath || i18n.language || DEFAULT_LANGUAGE),
    [languageFromPath, i18n.language],
  );

  const handleChange = (event) => {
    const nextLanguage = resolveLanguageFromParam(event.target.value, currentLanguage);
    if (nextLanguage === currentLanguage) {
      return;
    }

    const targetUrl = buildLocalizedUrl(location.pathname, nextLanguage, location.search, location.hash);

    i18n.changeLanguage(nextLanguage);
    persistLanguage(nextLanguage);
    persistAuthLanguage(nextLanguage);
    navigate(targetUrl, { replace: true });
  };

  const languageOptions = [
    { value: 'ua', label: 'UA' },
    { value: 'ru', label: 'RU' },
    { value: 'en', label: 'EN' },
  ];

  return (
    <div className="auth-language-switcher">
      <select
        id="auth-language"
        className="auth-language-switcher__select"
        aria-label="Language"
        value={currentLanguage}
        onChange={handleChange}
      >
        {languageOptions.map((option) => (
          <option key={option.value} value={option.value} disabled={!SUPPORTED_LANGUAGES.includes(option.value)}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default AuthLanguageSwitcher;
